export default __webpack_public_path__ + "static/media/image14tum.130f28c3.jpg";